import { render, staticRenderFns } from "./ReportBilling.vue?vue&type=template&id=45087a50&scoped=true"
import script from "./ReportBilling.vue?vue&type=script&lang=js"
export * from "./ReportBilling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45087a50",
  null
  
)

export default component.exports